<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <cliente-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ClienteCrud from "./ClienteCrud";
    export default {
        name: "ClienteManagementPage",
        components: {ClienteCrud}
    }
</script>

<style scoped>

</style>
